<template>
    <main
        class="py-14 md:py-28 lg:py-24 mx-4 lg:mx-40 space-y-4 lg:space-y-6"
    >
      <section>
        <account-types></account-types>
        <div class="lg:pr-4 space-y-4 text-base mt-32 w-full">
          <h4
              class="text-primar-400 text-base font-semibold uppercase"
            >
              {{ $t('accountTypes.footerTitle') }}
            </h4>
          <h2 class="text-primar-400 text-sm leading-6">
            
            {{ $t('accountTypes.footerText') }}
          </h2>
          <h3 class="text-primar-400 text-sm leading-6 font-semibold text-center">
            {{ $t('accountTypes.footerFooter') }}
          </h3>
      </div>
      </section>
    </main>
  </template>
  <script>
  import AccountTypes from '../components/AccountTypes.vue';

export default {
  components: {
    AccountTypes
  }
}
</script>
  <style>
  </style>